import React, { PureComponent } from 'react';
import { InfluencerInviteScreen } from 'fitbeat.react-native-components';
import { HomeCarouselAuthLayout } from '../Layouts/HomeCarouselAuthLayout';

interface IProps {
  navigation: any;
  influencerName: string;
  influencerId: string;
  avatar: string | null;
  landingPage: string | null;
  personalisedHeader: string | null;
}

export class InfluencerInviteScreenContainer extends PureComponent<IProps> {
  public render() {
    const { avatar } = this.props;
    return (
      <HomeCarouselAuthLayout
        hasAccessToAStudioGym={false}
        hideScroll={true}
        firstSliderImageSource={avatar && `data:image/png;base64,${avatar}`}
      >
        <InfluencerInviteScreen {...this.props }/>
      </HomeCarouselAuthLayout>
    );
  }
}
